import { TableStore } from "../TableStore";
import { BaseColumn } from "./BaseColumn";
import { ReferColumn } from "./ReferColumn";
import { NumberColumn } from "./NumberColumn";
import { ColumnsType, isRefer, isCharacter, isNumber } from "../types";
import { CharacterColumn } from "./CharacterColumn";

export class ColumnFactory {

  static getStoreAlias(column: ColumnsType) {
    // 优先级  storeField ----> alias
    return column.storeAlias || column.storeField || column.alias
  }
  /**
   * 更新已经存在的Column 新老进行一次合并
   * @param oldC 已经存在
   * @param newC 新传入的值
   * @param tableStore
   * @returns
   */
  static updateColumn(oldC: BaseColumn, newC: ColumnsType, tableStore: TableStore) {
    newC.field = oldC.field // 这次是Meta数据中补充的缺少实体字段的field
    // table 渲染会重新初始化columns
    return ColumnFactory.buildColumn(oldC.storeAlias, newC, tableStore)
  }
  static buildColumn(storeAlias: string, column: ColumnsType, tableStore: TableStore) {
    column.storeAlias = storeAlias
    const newC = ColumnFactory.createColumn(column, tableStore)
    return newC
  }
  static createColumn(column: ColumnsType, tableStore: TableStore) {
    if (isRefer(column.controlType)) {
      return new ReferColumn(column, tableStore);
    } else if (isCharacter(column)) {
      return new CharacterColumn(column, tableStore)
    } else if (isNumber(column.controlType)) {
      return new NumberColumn(column, tableStore)
    }
    return new BaseColumn(column, tableStore);
  }
}
